import { Attr, BelongsTo, Model } from "spraypaint";

import { attachmentUrl } from "shared/helpers/attachment";
import type { SocialAltTextData } from "shared/modals/SocialAltTextModal/types";
import { ApplicationRecord } from "shared/services/spraypaint";

import type ActiveStorageBlob from "./ActiveStorageBlob";

type AttachmentBlobAttributes = {
  readonly proxyUrl: string;
  readonly url: string;
  readonly video?: boolean;
};

@Model()
class ActiveStorageAttachment extends ApplicationRecord {
  static jsonapiType = "active_storage_attachments";

  @BelongsTo({ name: "blob" }) activeStorageBlob: ActiveStorageBlob;

  @Attr({ persist: false }) altTextData?: SocialAltTextData[];

  @Attr() blobId: string;

  @Attr({ persist: false }) createdAt: string;

  @Attr() description: string;

  @Attr({ persist: false }) filename: string;

  @Attr() name: string;

  @Attr() position: number;

  @Attr({ persist: false }) url: string;

  get isAltTextAppliedToAll(): boolean {
    // todo: B/E needs to return a flag in order to determine if the user
    // checked "Apply alt text to all platforms" when they added alt text to the attachment.
    // For now, we'll just return false and uncheck the "Apply alt text to all platforms" checkbox in the UI.
    return false;
  }

  blobAttributes(): AttachmentBlobAttributes {
    const url = attachmentUrl(this.activeStorageBlob);

    return {
      proxyUrl: url.replace("/redirect/", "/proxy/"),
      url,
      video: this.activeStorageBlob.video,
    };
  }
}

export default ActiveStorageAttachment;
